import { createTheme } from '@material-ui/core/styles';

// Customizing the theme
const theme = {
  palette: {
    primary: {
      main: '#4c555c',
    },
    secondary: {
      main: '#4c555c',
    },
  },
  typography: {
    fontFamily: 'Open Sans',
  },
  overrides: {
    MuiCard: {
      root: {
        '&.faq-card': {
          paddingRight: '15px',
        },
      },
    },
    MuiCardContent: {
      root: {
        '&.faq-card-text': {
          marginRight: '40px',
        },
      },
    },
    MuiCardHeader: {
      action: {
        marginRight: 0,
      },
      title: {
        color: '#7a848b',
      },
    },
    MuiCheckbox: {
      root: {
        color: '#4c555c',
      },
    },
    MuiDialog: {
      root: {
        paddingRight: 0, // fixes bug, where in some browsers a right padding was visible
      },
      paper: {
        margin: 0,
      },
    },
    MuiDialogActions: {
      root: {
        margin: 0,
        padding: 0,
      },
      spacing: {
        margin: 0,
      },
    },
    MuiDialogContent: {
      root: {
        borderRadius: '4px',
        minHeight: '200px',
        padding: 0,
        '&:first-child': {
          paddingTop: 0,
        },
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: '12px',
        color: 'rgba(0,0,0,0.3)',
      },
    },
    MuiFormControlLabel: {
      label: {
        color: '#7a848b',
      },
    },
    MuiInput: {
      root: {
        background: 'transparent',
      },
      input: {
        '&::placeholder': {
          fontSize: '12px',
        },
      },
      underline: {
        '&:before': {
          borderBottom: '1px solid rgb(224, 224, 224)',
        },
        '&:hover': {
          '&:before': {
            borderBottom: '1px solid rgb(224, 224, 224) !important;',
          },
        },
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '14px',
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: '10px',
        textTransform: 'uppercase',
      },
    },
    MuiSelect: {
      root: {
        background: 'transparent',
        fontSize: '14px',
      },
      selectMenu: {
        background: 'transparent',
        '&:focus': {
          background: 'transparent',
        },
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '14px',
        lineHeight: '14px',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#0e1921',
      },
    },
    MuiStepper: {
      root: {
        background: 'transparent',
      },
    },
    MuiStepLabel: {
      alternativeLabel: {
        fontSize: '12px',
      },
    },
    MuiSwitch: {
      colorPrimary: {
        color: '#1788da',
        '&$checked': {
          color: '#1788da',
          '& + $track': {
            backgroundColor: '#1788da',
          },
        },
      },
    },
    MuiSnackbar: {
      root: {
        zIndex: 99999,
      },
    },
    MuiTabs: {
      indicator: {
        backgroundColor: '#a9adb1',
      },
    },
    MuiTab: {
      root: {
        backgroundColor: '#f6f8f9',
        color: '#7a848b',
        fontWeight: 'bold',
      },
    },
  },
};

export const customMuiTheme = createTheme(theme);
